import { Button } from "react-bootstrap";
import React from "react";
import styles from "./../Main.module.scss";
import { Link } from "react-router-dom";

const Pagination = ({ currentPage, pagination }) => {
  return (
    <div className={styles.pagination}>
      <Link to={pagination.toStart}>
        <Button variant="info" className={styles.paginationButton}>
          {"<<"}
        </Button>
      </Link>
      <Link to={pagination.back}>
        <Button variant="info" className={styles.paginationButton}>
          {"<"}
        </Button>
      </Link>
      {currentPage}
      <Link to={pagination.forward}>
        <Button variant="info" className={styles.paginationButton}>
          {">"}
        </Button>
      </Link>
      <Link to={pagination.toEnd}>
        <Button variant="info" className={styles.paginationButton}>
          {">>"}
        </Button>
      </Link>
    </div>
  );
};

export default Pagination;
